"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _contentType = _interopRequireDefault(require("../model/content-type"));

var _item = _interopRequireDefault(require("../model/item"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  settings: _propTypes["default"].shape({
    errorMessage: _propTypes["default"].string,
    dataEndpoint: _propTypes["default"].string,
    maxListCount: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
    baseEndpoint: _propTypes["default"].string
  }),
  dictionary: _propTypes["default"].shape({
    filterby: _propTypes["default"].string,
    viewall: _propTypes["default"].string,
    showresults: _propTypes["default"].string,
    contenttypes: _propTypes["default"].string,
    viewallitems: _propTypes["default"].string,
    back: _propTypes["default"].string,
    download: _propTypes["default"].string,
    file: _propTypes["default"].string,
    pdf: _propTypes["default"].string,
    img: _propTypes["default"].string,
    video: _propTypes["default"].string,
    embed: _propTypes["default"].string,
    loadmore: _propTypes["default"].string
  }),
  contentTypes: _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(_contentType["default"])),
  item: _propTypes["default"].instanceOf(_item["default"])
};
exports["default"] = _default;